import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ChatMessage } from 'clients/ChatClient';
import agLogo from 'assets/airgarage-logo.png';
import ChatChart from './ChatChart';
import styles from './MessageBubble.module.css';

interface MessageBubbleProps {
    message: ChatMessage;
    isStreaming: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isStreaming }) => {
    const isUser = message.role === 'user';
    const charts = message.charts || [];

    return (
        <div className={`${styles.row} ${isUser ? styles.userRow : styles.assistantRow}`}>
            {!isUser && <img src={agLogo} alt="AirGarage" className={styles.avatar} />}
            <div className={`${styles.bubble} ${isUser ? styles.userBubble : styles.assistantBubble}`}>
                {charts.length > 0 && (
                    <div className={styles.charts}>
                        {charts.map((chart, i) => (
                            <ChatChart key={i} spec={chart} />
                        ))}
                    </div>
                )}
                <div className={styles.content}>
                    {isUser ? (
                        message.content
                    ) : message.content ? (
                        <ReactMarkdown>{message.content}</ReactMarkdown>
                    ) : isStreaming ? (
                        <span className={styles.typing}>Thinking...</span>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
